<template>
    <!-- see prototype: dummy-toast.html -->
    <div class="toast-container">
        <div id="cookieToast" ref="cookiesBanner" class="toast toast-cookies" role="alert" data-bs-autohide="false">
            <div class="toast-header">
                <strong class="ms-2 me-auto">{{$t('privacy.thisSiteUsesCookies')}}</strong>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button> -->
            </div>
            <div class="toast-body">                        
                <button type="button" class="btn btn-primary btn-sm me-3" data-bs-dismiss="toast" @click="$parent.acceptAllCookies">{{$t('privacy.acceptAll')}}</button>
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="toast" data-bs-target="#toast-cookie" @click="$parent.showCookieOptions">{{$t('privacy.preferences')}}</button> 
            </div>
        </div>
    </div>
</template>

